import React from 'react';
import { Card, Button, Input } from 'antd';

class SimilarWebMassOpen extends React.Component{

	render(){

		return (
			<Card style={{ width: 400 }}>
				<h2>Similar Web List</h2>
				
				<Input.TextArea	
					style={{ height: 400 }}
					value={this.state.similarWebUrls} 
					onChange={ e => this.setState({ similarWebUrls: e.target.value }) } 
					placeholder="Enter URLs line by line"/>

				<br/>
				<br/>

				<Button onClick={ this.openSimilarWeb }>
					Open Similar Web
				</Button>
			</Card>
		)

	}

	constructor( props ){
		super(props);

		this.state = {
			similarWebUrls:''
		};
	}

	openSimilarWeb = () => {
		
		const { similarWebUrls } = this.state;


		let urls = similarWebUrls.split('\n');

		urls.map( (url, index) => {
			
			if( url ){
				setTimeout( () => {
					window.open( `https://www.similarweb.com/website/${url.trim()}` );
				}, index * 1000 );
			}

			return null;

		}); 

	}

}

class AdPage extends React.Component{

	render(){

		return (
			<div>
				<SimilarWebMassOpen />


			</div>
		)

	}

}

export default AdPage;


// WEBPACK FOOTER //
// ./src/containers/ads-page.js